import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Input, Modal } from "ui";

import { useCancelTransfer } from "../../apis";
import { Transfer } from "../../transfers.types";

interface CancelTransferModalProps {
  isOpen: boolean;
  transfer: Transfer | null;
  onClose: () => void;
  refetch: () => void;
}

const CancelTransferModal = ({
  isOpen,
  transfer,
  onClose,
  refetch,
}: CancelTransferModalProps) => {
  const { t } = useTranslation();
  const [note, setNote] = useState("");

  useEffect(() => {
    setNote("");
  }, [isOpen, transfer]);

  const { mutate: cancelTransfer, isLoading } = useCancelTransfer({
    onSuccess: () => {
      toast.success(t("Transfer cancelled successfully"));
      refetch();
      onClose();
    },
  });

  const handleCancel = () => {
    if (!transfer) {
      return;
    }
    cancelTransfer({ transferId: transfer.id, note: note.trim() || undefined });
  };

  return (
    <Modal
      isOpen={isOpen}
      title="Cancel transfer"
      isLoading={isLoading}
      okText="Cancel transfer"
      cancelText="Close"
      type="delete"
      onClose={onClose}
      onOk={handleCancel}
    >
      <p>
        {t(
          "Items still in transit will be returned to their source boxes. Items already placed stay where they are. This cannot be undone.",
        )}
      </p>
      <Input
        asTag="textarea"
        label="Reason (optional)"
        placeholder="Why are you cancelling this transfer?"
        value={note}
        onChange={(e) => setNote(e.target.value)}
      />
    </Modal>
  );
};

export default CancelTransferModal;
